// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__xuQYe","rotator":"styles_rotator__pbaWm","path":"styles_path__ypuBR","dash":"styles_dash__Jsx9g","colors":"styles_colors__iceDR"};